import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { clearTotalCount } from "../../../store/actions/documentsWithSearch/index";

import MacroCategoryFilter from "./macroCategoryFilter";
import ReadUnreadToggle from "./readUnreadToggle";
import Sorter from "./sorter";
import SwitcherViewType from "./switcherViewType";
import Search from "./search";

const TopControls = props => {
  const {
    handleGetDocumentsWithSearch,
    changeView,
    documentView,
    macroCategories,
    resetAllFilter,
    updateState
  } = props;

  const totalCount = useSelector(state => state.documentsWithSearch.totalCount);
  const dispatch = useDispatch();

  const [macroCount, setMacroCount] = useState(0);

  useEffect(() => {
    if (macroCount === 0 && totalCount > 0) {
      setMacroCount(totalCount);
    }
    return () => {
      setMacroCount(0);
      dispatch(clearTotalCount());
    };
  }, []);

  return (
    <div className="" style={{ marginTop: "32px" }}>
      <MacroCategoryFilter
        handleGetDocumentsWithSearch={handleGetDocumentsWithSearch}
        macroCategories={macroCategories}
        resetAllFilter={resetAllFilter}
      />

      <div style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "flex-end",
            justifyContent: "space-between",
            padding: "16px 0"
          }}
        >
          <Search
            handleGetDocumentsWithSearch={handleGetDocumentsWithSearch}
            updateState={updateState}
          />
          <Sorter
            handleGetDocumentsWithSearch={handleGetDocumentsWithSearch}
          />
          <ReadUnreadToggle
            handleGetDocumentsWithSearch={handleGetDocumentsWithSearch}
          />
          <SwitcherViewType
            changeView={changeView}
            documentView={documentView}
          />
        </div>
      </div>
    </div>
  );
};
export default TopControls;
